import React from 'react';
import PropTypes from 'prop-types';
import useLanguage from '../../../../hooks/useLanguage';

const MailInput = ({ mail, setMail }) => {
  const langToggle = useLanguage;
  return (
    <div className="free__form-input__wrapper form-animate">
      <label className="free__form-label">
        {langToggle('e-mail:', 'e-mail:')}
      </label>
      <input
        type="email"
        placeholder={langToggle('Введіть ваш e-mail', 'Введите ваш e-mail:')}
        value={mail}
        onChange={(e) => setMail(e.target.value)}
        required
      />
    </div>
  );
};

MailInput.propTypes = {
  mail: PropTypes.string,
  setMail: PropTypes.func,
};

export default MailInput;
